var baseStagingIframeUrl = "";
var baseStagingUrls = {
  finam: baseStagingIframeUrl ? "".concat(baseStagingIframeUrl, "/finam") : 'https://auth-finam.finam.dev',
  spc: baseStagingIframeUrl ? "".concat(baseStagingIframeUrl, "/j2t") : 'https://auth-lime.finam.dev',
  mma: baseStagingIframeUrl ? "".concat(baseStagingIframeUrl, "/mma") : 'https://auth-mma.finam.dev'
};
var iframeSourceByVariantProd = {
  prod: {
    finam: 'https://txauth.finam.ru',
    spc: 'https://txauth.scorepriority.com',
    mma: 'https://txauth.j2t.com'
  },
  dev: baseStagingUrls,
  preprod: baseStagingUrls
};
var iframeSourceByVariantShowcase = {
  prod: baseStagingUrls,
  dev: baseStagingUrls,
  preprod: baseStagingUrls
};
var baseLocalIframeUrl = 'http://localhost:8080';
var baseLocalUrls = {
  finam: "".concat(baseLocalIframeUrl, "/finam"),
  spc: "".concat(baseLocalIframeUrl, "/j2t"),
  mma: "".concat(baseLocalIframeUrl, "/mma")
};
var iframeSourceByVariantLocal = {
  prod: baseLocalUrls,
  dev: baseLocalUrls,
  preprod: baseLocalUrls
};
var iframeSourceByVariant = false ? true && !false ? iframeSourceByVariantShowcase : iframeSourceByVariantLocal : iframeSourceByVariantProd;
export var getIframeSource = function getIframeSource(env, variant) {
  var variantSource = iframeSourceByVariant[env][variant];

  if (!variantSource) {
    throw Error('variant is not correct');
  }

  return "".concat(variantSource, "/v", "6.0.1", "/iframe.html");
};
export default (function (iframeSrc) {
  return new Promise(function (resolve, reject) {
    var iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.width = '0';
    iframe.height = '0';
    iframe.hidden = true;

    iframe.onload = function () {
      return resolve(iframe);
    };

    iframe.onerror = function (error) {
      return reject(error);
    };

    document.body.appendChild(iframe);
  });
});